import { ValueOf } from "../types";
import { Base } from "./base";
import { Company } from "./company";

export interface Milestone extends Base {
  status?: string;
  reference?: string;
  title: string;
  description?: string;
  type: string;
  from: string;
  isRequired?: boolean;
  companyId?: number;
  company?: Company;
  sequence?: number;
}

export enum MilestoneType {
  ESTIMATED = "estimated",
  ACTUAL = "actual",
}

export enum MilestoneFrom {
  SHIPMENT = "shipment",
  ORDER = "order",
}

export interface MilestoneValue extends Omit<Base, "companyId"> {
  dateValue?: string;
  value?: string;
  comment?: string;
  milestoneId?: number;
  milestone?: Milestone;
  orderId?: number;
  shipmentId?: number;
}

export const MilestoneReference = {
  WAYBILL: {
    ESTIMATED: {
      TIME_ARRIVAL: "estimatedTimeOfArrival",
      TIME_DEPARTURE: "estimatedTimeOfDeparture",
    },
    ACTUAL: {
      DESTINATION: "actualArrivalOfDestination",
      DEPARTURE: "actualDepartureDate",
      DEPARTURE_DOCK: "actualAtDepartureDock",
    },
  },
  SHIPMENT: {
    ESTIMATED: {
      ORIGIN: "estimatedOrigin",
      DESTINATION: "estimatedDestination",
      DELIVERY_DATE: "estimatedDeliveryDate",
      WAREHOUSE: "etaWarehouse",
      UNPACK: "etaUnpack",
    },
    ACTUAL: {
      SCANNED_DATE: "actualScannedDate",
      PICKUP_ORIGIN: "actualPickupOrigin",
      ORIGIN: "actualOrigin",
      DESTINATION: "actualDestination",
      DELIVERY_DATE: "actualDeliveryDate",
      ARRIVAL_AT_DESTINATION: "arrivalAtDestination",
      DEPARTURE: "departure",
    },
  },
  ORDER: {
    ESTIMATED: {
      LOADING: "estimatedLoading",
      PICKUP_ORIGIN: "estimatedPickupOrigin",
      ETD_ORIGIN: "estimatedEtdOrigin",
      ETA_DESTINATION: "estimatedEtaDestination",
    },
    ACTUAL: {
      CUSTOMER_DATE: "customerOrderDate",
      LOADING: "actualLoading",
      PICKUP_ORIGIN: "actualPickupOrigin",
      ETD_ORIGIN: "actualEtdOrigin",
      ETA_DESTINATION: "actualEtaDestination",
    },
  },
};

export type MilestoneReferenceOrder =
  | ValueOf<typeof MilestoneReference.ORDER.ESTIMATED>
  | ValueOf<typeof MilestoneReference.ORDER.ACTUAL>;

export type MilestoneReferenceShipment =
  | ValueOf<typeof MilestoneReference.SHIPMENT.ESTIMATED>
  | ValueOf<typeof MilestoneReference.SHIPMENT.ACTUAL>;
